/**
 * @generated SignedSource<<0c2286134fab527e41bd97753af1e6d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EmployeeShiftStatus = "ACTIVE" | "PAST" | "UPCOMING";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
import { FragmentRefs } from "relay-runtime";
export type WidgetEmployeeSchedule_widgetEmployeeSchedule$data = {
  readonly employeesWithShifts: ReadonlyArray<{
    readonly id: string;
    readonly shifts: ReadonlyArray<{
      readonly status: EmployeeShiftStatus;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeScheduleShiftsEmployee_employee">;
  }>;
  readonly id: string;
  readonly overviewSize: WidgetOverviewSize;
  readonly teams: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeScheduleIcon_widgetEmployeeSchedule">;
  readonly " $fragmentType": "WidgetEmployeeSchedule_widgetEmployeeSchedule";
};
export type WidgetEmployeeSchedule_widgetEmployeeSchedule$key = {
  readonly " $data"?: WidgetEmployeeSchedule_widgetEmployeeSchedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeSchedule_widgetEmployeeSchedule">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetEmployeeSchedule_widgetEmployeeSchedule",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overviewSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetEmployeeScheduleIcon_widgetEmployeeSchedule"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employeesWithShifts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeShift",
          "kind": "LinkedField",
          "name": "shifts",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetEmployeeScheduleShiftsEmployee_employee"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetEmployeeSchedule",
  "abstractKey": null
};
})();

(node as any).hash = "3c4cd0c63bc37ad3a204ed00d21be18f";

export default node;
